<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="view === 'pos' ? customerService.customer.value.visits : customerService.customer.value.onlineOrders"
	dataKey="canvasKey"
	[paginator]="customerService.customer.value.visits && customerService.customer.value.visits.length > 25"
	[rows]="25"
	[showCurrentPageReport]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[25, 50, 100]"
	[globalFilterFields]="['checkNumber', 'total']"
>
	<ng-template pTemplate="header" #header>
		<tr>
			<th pSortableColumn="created">
				Date
				<p-sortIcon field="created"></p-sortIcon>
			</th>
			<th pSortableColumn="checkNumber">
				Check #
				<p-sortIcon field="checkNumber"></p-sortIcon>
			</th>
			<th pSortableColumn="table">
				Table
				<p-sortIcon field="table"></p-sortIcon>
			</th>
			<th pSortableColumn="owner">
				Owner
				<p-sortIcon field="owner"></p-sortIcon>
			</th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="index">
		<tr>
			<td>
				<span class="p-column-title">Date</span>
				{{ moment(rec.created).format("l LT") }}
			</td>
			<td>
				<span class="p-column-title">Check #</span>
				{{ rec.checkNumber }}
			</td>
			<td>
				<span class="p-column-title">Table</span>
				{{ rec.table }}
			</td>
			<td>
				<span class="p-column-title">Owner</span>
				{{ rec.owner }}
			</td>
			<td>
				<div>
					<p-button pRipple styleClass="p-button p-button-raised  m-2" (click)="viewCheck(rec.checkKey)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'question-circle']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</div>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="5" style="text-align: center">No check visits found.</td>
		</tr>
	</ng-template>
</p-table>

<p-sidebar
	*ngIf="checkSelected"
	[(visible)]="checkSelected"
	position="right"
	appendTo="body"
	(onHide)="checkSelected = undefined"
	[showCloseIcon]="false"
	styleClass="p-sidebar-md"
>
	<app-check-record-viewer [incomingCheck]="checkSelected"></app-check-record-viewer>
</p-sidebar>
